import { useEffect, useMemo, useState } from "react";

import { Column } from "@bridgesplit/ui";
import {
    AbfLoanExpanded,
    getZcLedger,
    isLoanDefaulted,
    isLoanLiquidated,
    LoopPositionExpanded
} from "@bridgesplit/abf-react";

import TopUp from "./TopUp";
import Withdraw from "./CollateralWithdraw";
import { ActionToggleButtons } from "./common";
import { getOptions } from "./util";
import { ManageLoanActions, ManualManageSubActions } from "../side-card/types";

export function AdjustCollateral({
    loanExpanded,
    loopPosition,
    isNestedDialogView = false
}: {
    loanExpanded: AbfLoanExpanded | undefined;
    loopPosition: LoopPositionExpanded | undefined;
    isNestedDialogView?: boolean;
}) {
    const isFullyRepaid = (getZcLedger(loanExpanded)?.ledgerDebt.total ?? 0) === 0;
    const isWithdrawOnly = isFullyRepaid || isLoanDefaulted(loanExpanded) || isLoanLiquidated(loanExpanded);
    const options = useMemo(() => {
        const collateralOptions = getOptions(ManageLoanActions.AdjustCollateral);
        if (!isWithdrawOnly) return collateralOptions;
        return collateralOptions.filter((option) => option.value === ManualManageSubActions.WithdrawCollateral);
    }, [isWithdrawOnly]);
    const [selectedAction, setSelectedAction] = useState<ManualManageSubActions>(options[0].value);

    useEffect(() => {
        if (options.some((option) => option.value === selectedAction)) return;
        setSelectedAction(options[0].value);
    }, [options, selectedAction]);

    return (
        <Column spacing={3}>
            {options.length > 1 && (
                <ActionToggleButtons
                    value={selectedAction}
                    setValue={setSelectedAction}
                    options={options}
                    isNestedDialogView={isNestedDialogView}
                />
            )}
            {selectedAction === ManualManageSubActions.TopUpCollateral && (
                <TopUp loanExpanded={loanExpanded} loopPosition={loopPosition} />
            )}
            {selectedAction === ManualManageSubActions.WithdrawCollateral && (
                <Withdraw loanExpanded={loanExpanded} loopPosition={loopPosition} />
            )}
        </Column>
    );
}
